var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12980_22609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75C1.7625 6.75 0.75 7.7625 0.75 9C0.75 10.2375 1.7625 11.25 3 11.25C4.2375 11.25 5.25 10.2375 5.25 9C5.25 7.7625 4.2375 6.75 3 6.75ZM3 10.5C2.175 10.5 1.5 9.825 1.5 9C1.5 8.175 2.175 7.5 3 7.5C3.825 7.5 4.5 8.175 4.5 9C4.5 9.825 3.825 10.5 3 10.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9H10.5C10.5 4.875 7.125 1.5 3 1.5V0.75C7.5375 0.75 11.25 4.4625 11.25 9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9H7.5C7.5 6.525 5.475 4.5 3 4.5V3.75C5.8875 3.75 8.25 6.1125 8.25 9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12980_22609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.457dddc6b3e6d5cd63f58c2c47af5621.svg";
export { ForwardRef as ReactComponent };